/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'rename-bucket',
  components: {},
  props: ['updateBucketDETAIL'],
  data () {
    return {
      rename:'',
      updateBucketId:''
    }
  },
  computed: {

  },
  mounted () {
    this.rename = this.updateBucketDETAIL.name
    this.updateBucketId = this.updateBucketDETAIL.id
  },
  methods: {
    getBucketListAgainMethod(){
      this.$store.dispatch('getBucketListOfAwerackFun').then((res)=>{
      }).catch((err) => {})
    },
    updateBucketNameBeforeSubmitMethod(){
      let data = {name:this.rename}
      this.$store.dispatch('updateBucketOfAwerackDetailsFun',{data:{id:this.updateBucketId,data:data}}).then((res)=>{
        toast.success(res.data.msg);
        this.getBucketListAgainMethod()
        this.closeRenameBucketPopup()
      }).catch((err)=>{})
    },
    closeRenameBucketPopup(){
      this.updateBucketId = ''
      bus.$emit('updateBucketPopupStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  }
}


